'use strict';

angular.module('ClinicApp')
  .config(function($stateProvider) {
    $stateProvider.state('clinic.appointments', {
      templateUrl: '/views/partials/clinic/appointments.html',
      params: {
        tab: {
          value: 'todo',
          squash: false,
          dynamic: true,
        },
      },
      controller: 'ClinicAppointmentsCtrl',
      url: 'appointments/?tab',
      resolve: {
        pageTitle: function($pageTitle, clinic) {
          $pageTitle.set(`Appointments - ${clinic.name} - Opencare`);
        },
        clinicIds: function(clinic) {
          return [clinic.id];
        },
      },
    });
  });

angular.module('ClinicApp')
  .config(function($stateProvider) {
    $stateProvider.state('all-appointments', {
      templateUrl: '/views/partials/clinic/appointments.html',
      params: {
        tab: {
          value: 'todo',
          squash: false,
          dynamic: true,
        },
      },
      controller: 'ClinicAppointmentsCtrl',
      url: '/all-appointments/?tab',
      resolve: {
        pageTitle: function($pageTitle) {
          $pageTitle.set('Appointments - Opencare');
        },
        clinicIds: async (ClinicService) => {
          const clinics = await ClinicService.getClinics();
          return clinics.map((clinic) => clinic.id);
        },
      },
    });
  });

angular.module('ClinicApp')
  .controller(
    'ClinicAppointmentsCtrl',
    (
      $scope,
      $element,
      $state,
      clinicIds,
      ClinicConfig,
      IframeService,
      OCModalUtil,
    ) => {
      $scope.currentTab = $state.params.tab;

      const element = $element[0];
      const iframeElement = element.querySelector('#js-appointment-iframe');
      const clinicIdUrlParam = clinicIds.length > 1 ? 'all-clinics' : clinicIds[0];
      const appointmentUri = encodeURI(`${ClinicConfig.CLINIC_APP_V4_URL}/#/clinic/${clinicIdUrlParam}/appointments?tab=${$scope.currentTab}`);

      iframeElement.src = appointmentUri;

      const onScroll = () => {
        const documentElement = document.documentElement;

        const scrollTop = documentElement.scrollTop;
        const documentTop = documentElement.getBoundingClientRect().top;
        const iframeTop = iframeElement.getBoundingClientRect().top;
        const viewportHeight = documentElement.clientHeight;

        const relativeScrollTop = scrollTop + (documentTop - iframeTop);
        const relativeScrollBottom = relativeScrollTop + viewportHeight;

        IframeService.sendMessage({
          iframe: iframeElement,
          type: 'scroll',
          data: {
            relativeScrollTop,
            relativeScrollBottom,
          },
        });
      };

      $scope.checkScrollbar = () => {
        const hasScrollbar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
        IframeService.sendMessage({
          iframe: iframeElement,
          type: 'hasScrollbar',
          data: hasScrollbar,
        });
      };

      $scope.viewAppointment = ({ appointmentId, clinicId }) => {
        $state.go('clinic.appointment', {
          id: clinicId,
          appointmentId,
          appointment: undefined,
          backTo: true,
        });
      };

      $scope.openVerifyAppointmentModal = ({ appointmentId }) => OCModalUtil.showModal('verifyAppointment', { appointmentId });

      $scope.setTab = ({ tab }) => {
        $state.go(
          $state.current.name,
          { tab },
          {
            inherit: true,
            notify: false,
            reload: false,
            location: 'replace',
          },
        );
      };

      $scope.goToProvidersTab = () => $state.go('clinic.schedule');

      document.addEventListener('scroll', onScroll);

      IframeService.setupFunctionCallHandler($scope);
      IframeService.addResizeHandler({
        getElement: () => element.querySelector('#appointment-list-container'),
      });

      $scope.$on('$destroy', function() {
        document.removeEventListener('scroll', onScroll);
      });
    },
  );
